import { gql } from '@apollo/client';
export interface GqlSeasonSummary {
  id: number;
  programId: number;
  tsDivisionId: number | null;
  name: string;
  activeTeamCount: number;
  activeAssignedPlayerCount: number;
  activeUnassignedPlayerCount: number;
  activeAssignedMemberCount: number;
  activeUnassignedMemberCount: number;
  activeCommissionerCount: number;
  activeManagerCount: number;
  activeRegistrationFormCount: number;
  activeRegistrationCompletedSignupCount: number;
}

export const ShowProgramSeasonSummaries = gql`
  query ProgramSeasonSummaries($organizationId: Int!, $isArchived: Boolean) {
    programSeasonSummaries(organizationId: $organizationId, isArchived: $isArchived) {
      id
      name
      programId
      activeTeamCount
      activeManagerCount
      activeCommissionerCount
      activeAssignedPlayerCount
      activeUnassignedPlayerCount
      activeAssignedMemberCount
      activeRegistrationFormCount
      activeUnassignedMemberCount
      activeRegistrationCompletedSignupCount
    }
  }
`;
